import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse, ICmsStationResponse } from "../../Orchestrator/Types/Index";
import { ICmsStopsResponse } from "../../Orchestrator/Types/Interface/ICmsStops";
export async function getCmsStopsList(): Promise<
  IApiResponse<ICmsStopsResponse>
> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCmsStops;

  const params = new URLSearchParams({
    "populate": "*",
    locale: await getLocaleFromCookie()
  });

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsStopsResponse>(endpointWithParams, "GET");
}

